import React from 'react';
import { Close } from '@radix-ui/react-dialog';
import type { DialogCloseProps } from '@radix-ui/react-dialog';
import { cn } from '@mentimeter/ragnar-tailwind-config';

export const ModalDismiss = ({ className, ...rest }: DialogCloseProps) => (
  <Close asChild {...rest} className={cn(className)} />
);
